import httpClient from '@/api/httpClient';

const configurationStringToConfigurationObject = configurationDataString => {
    return httpClient.get(`configuration-data-string/${configurationDataString}`)
        .then(({ data }) => data);
};

export default {
    configurationStringToConfigurationObject,
};
